import StandaloneEntrypoint from './Layouts/Standalone/StandaloneEntrypoint';
import store from './Redux/ReduxStore';
import applicationInitializationService from './Refactor/Services/ApplicationInitializationService';

applicationInitializationService.registerAll(false, store);

const App = () => <StandaloneEntrypoint />;

export default App;
